/* svnty-quickadd.js: THE FAST ADD + THE FAST DOOR (D4-34, 2026-09-25, 04:16 to 04:20, images 108 to 110).
 * Classic, deferred, no deps, ES5, ASCII. Words: window.svntyStrings.qa only (snippets/svnty-qa-strings.liquid).
 *
 * 1. THE SIZE ROW. Every card's action row is [CHOOSE OPTIONS][the bag]. The bag reads the card's compact variant map
 *    (data-svnty-qa-json on the card's .svnty-qa, snippets/card-product.liquid: [id, colour, size label, available]) for the colour the
 *    card shows now (the pressed swatch, which svnty-card.js keeps: the session memory, the page's colour on a product
 *    page); one variant in that colour adds at once, more open THE SIZE ROW over the action row, in place: the row's
 *    height is kept (THE ROW LAW: nothing below moves), chips in stock plain, sold out struck, a close X at the end. A
 *    size tap adds through the store's one add path (window.SVNTYCartAdd: /cart/add with the bag section, the toast, the
 *    counted bag), the chip spins alone at its own width, then "Added" with a check for 1.2 s, or "Not available" for
 *    1.6 s, and the action row returns. A swatch change while the row is open repaints the chips. Outside, Escape, the
 *    X or another card's bag close it; Escape and the X give focus back to the bag.
 * 2. THE FAST DOOR (D4-34; v2 D6-16): window.SVNTYDoor.door(url) answers every CHOOSE OPTIONS with the lean door section
 *    (sections/svnty-door.liquid), prefetched for every card in view (section 2 below); assets/quick-add.js writes it. */
(function () {
  'use strict';
  var STR = function (k, d) { var q = (window.svntyStrings && window.svntyStrings.qa) || {}; return q[k] || d || ''; };
  var ADDED_MS = 1200, NA_MS = 1600;
  var slice = function (l) { return Array.prototype.slice.call(l); };
  function measureRows() { try { if (window.SVNTY && window.SVNTY.rows) requestAnimationFrame(window.SVNTY.rows.measure); } catch (e) {} }

  /* ============================================================ 2. THE FAST DOOR (first: the size row uses nothing of it)
     D6-16 THE QUICK LOOK DOOR v2 (R206, 21:10): the door is ONE lean section, sections/svnty-door.liquid, asked through the
     Section Rendering API (/products/<handle>?variant=<id>&section_id=svnty-door, under 40 KB for a nine-colour piece; the old
     door fetched the product page's whole main section, about 0.5 MB, and wrote 118 KB and 11 scripts on every open). Its text is
     parsed ONCE when it arrives (its ids renamed to the door's own, quickadd-svnty-door, so the page's subscribers never take a
     door pick), and kept, with its first picture fetched and decoded at the door's own size, so an open only writes a string and
     paints from cache. THE KIT (window.SVNTYDoorKit, snippets/svnty-qa-strings.liquid): the five scripts and six sheets the
     door's parts run on, loaded with the first door and never again. THE PREFETCH: every card in view, one fetch at a time,
     nearest the viewport's centre first, only after 200 ms without a scroll, at idle, never on Save-Data or a 2G or 3G link,
     1.5 MB a page view at most, the newest 24 doors kept (an LRU); a mouse resting 80 ms, a finger held, a keyboard focus and a
     swatch pick on the card jump the queue. Trade's whole page stays the fallback when the section cannot be had (404). */
  var SID = 'svnty-door', LRU = 24, BUDGET = 1500000, CALM_MS = 200;
  var cache = new Map(), bytes = 0, inflight = 0, skip = new Set(), restUntil = 0, misses = 0;   /* P28-4 (lane G P1-1 THE DOOR PREFETCH STORM): a refused prefetch is never asked again by the pump this page view; a miss rests the pump 2 s x misses; three misses in a row stop it; the shopper's own press still opens the door */
  function withSid(url, s) { return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + encodeURIComponent(s); }
  function key(url) { try { var u = new URL(url, location.href); u.searchParams.delete('section_id'); return u.pathname + u.search; } catch (e) { return url; } }
  function assetPath(u) { try { return new URL(u, location.href).pathname; } catch (e) { return String(u || '').split('?')[0]; } }
  function slow() { var c = navigator.connection; return !!(c && (c.saveData || /(^|-)(2g|3g)$/.test(c.effectiveType || ''))); }

  /* THE KIT: loaded once, resolved when every script has run and every sheet has applied (a door never paints unstyled) */
  var kitP = null;
  function ensureKit() {
    if (kitP) return kitP;
    var K = window.SVNTYDoorKit || {}, waits = [];
    var haveJs = {}, haveCss = {};
    slice(document.querySelectorAll('script[src]')).forEach(function (s) { haveJs[assetPath(s.src)] = 1; });
    slice(document.querySelectorAll('link[rel="stylesheet"]')).forEach(function (l) { haveCss[assetPath(l.href)] = 1; });
    (K.css || []).forEach(function (h) {
      if (haveCss[assetPath(h)]) return;
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = h; l.setAttribute('data-svnty-door-css', '');
      waits.push(new Promise(function (r) { l.onload = l.onerror = r; }));
      document.head.appendChild(l);
    });
    (K.js || []).forEach(function (h) {
      if (haveJs[assetPath(h)]) return;
      var s = document.createElement('script'); s.src = h; s.async = false; s.setAttribute('data-svnty-door-js', '');
      waits.push(new Promise(function (r) { s.onload = s.onerror = r; }));
      document.head.appendChild(s);
    });
    /* the buy row's words and share glyph (svnty-buyrow.js reads them; the product page prints its own) */
    var S = window.svntyStrings = window.svntyStrings || {}, W = K.words || {};
    if (!S.share) S.share = { label: W.share, copied: W.copied };
    if (!S.stock) S.stock = { in: W.in, out: W.out };
    S.wishlist = S.wishlist || {}; if (!S.wishlist.add && W.wl) S.wishlist.add = W.wl;
    if (K.glyph && !document.getElementById('svnty-share-glyph')) {
      var t = document.createElement('template'); t.id = 'svnty-share-glyph'; t.innerHTML = K.glyph; document.body.appendChild(t);
    }
    kitP = Promise.all(waits).then(function () { return true; });
    return kitP;
  }
  /* THE PREPARED DOOR: the section parsed once; the string the open writes, the first picture's candidates */
  function prepare(text) {
    if (!text || text.indexOf('data-svnty-qd') < 0) return null;
    var doc = new DOMParser().parseFromString(text.split(SID).join('quickadd-' + SID), 'text/html');
    var root = doc.querySelector('[data-svnty-qd]'); if (!root) return null;
    slice(root.querySelectorAll('variant-selects, product-info')).forEach(function (n) { n.dataset.originalSection = SID; });
    /* a <link rel=stylesheet> written with the door (the loading spinner's snippet prints one) is a new sheet for the WHOLE page:
       every element restyled on every open (measured: 60 to 70 ms of WebKit's frame on the collection page). The sheet is
       hoisted into <head> once; the door's string carries none. */
    slice(root.querySelectorAll('link[rel="stylesheet"], style')).forEach(function (l) {
      if (l.tagName === 'LINK') {
        var h = l.getAttribute('href'), have = slice(document.querySelectorAll('link[rel="stylesheet"]')).some(function (x) { return assetPath(x.href) === assetPath(h); });
        if (h && !have) { var n = document.createElement('link'); n.rel = 'stylesheet'; n.href = h; document.head.appendChild(n); }
      }
      l.parentNode.removeChild(l);
    });
    var f = root.querySelector('img[data-svnty-qd-first]');
    return { lean: true, sid: SID, classes: [], html: root.innerHTML, bytes: text.length, handle: root.getAttribute('data-handle') || '',
      pic: f ? { src: f.getAttribute('src'), srcset: f.getAttribute('srcset') || '', sizes: f.getAttribute('sizes') || '' } : null };
  }
  function get(url) {
    return fetch(withSid(url, SID), { credentials: 'same-origin' }).then(function (r) {
      if (r.status === 404) return null;          /* no section on this theme: Trade's road (assets/quick-add.js) */
      if (!r.ok) throw new Error('door ' + r.status);
      return r.text();
    });
  }
  function touch(k, e) { cache.delete(k); cache.set(k, e); while (cache.size > LRU) cache.delete(cache.keys().next().value); }
  function door(url) {
    var k = key(url), e = cache.get(k);
    if (e) { touch(k, e); return e.door; }
    e = {};
    e.door = Promise.all([get(url), ensureKit()]).then(function (r) { var p = prepare(r[0]); if (p) warm(p); return p; });
    e.door.then(function (p) { if (!p && cache.get(k) === e) cache.delete(k); }, function () { if (cache.get(k) === e) cache.delete(k); });
    touch(k, e);
    return e.door;
  }
  /* the first picture, fetched and decoded at the door's size by the same candidates the door's <img> will choose */
  function warm(p) {
    if (!p.pic || p.picP) return p.picP;
    var im = new Image();
    im.decoding = 'async'; if (p.pic.sizes) im.sizes = p.pic.sizes; if (p.pic.srcset) im.srcset = p.pic.srcset; im.src = p.pic.src;
    p.img = im;   /* held: the decoded frame stays with the page's image cache */
    p.picP = (im.decode ? im.decode() : new Promise(function (r) { im.onload = r; })).then(function () { return true; }, function () { return false; });
    return p.picP;
  }
  function ready(url) { return door(url).then(function (p) { return p ? (warm(p) || true) : null; }).then(function () { return door(url); }); }
  function cached(url) { return cache.has(key(url)); }
  window.SVNTYDoor = { door: door, ready: ready, cached: cached, sid: function () { return SID; }, kit: ensureKit,
    clear: function () { cache = new Map(); }, stats: function () { return { bytes: bytes, doors: cache.size, inflight: inflight }; } };

  /* ------------------------------------------------------------ THE PREFETCH FOR EVERY CARD IN VIEW */
  var CARD = '.card-wrapper';   /* P17-26: the wishlist's own card (svnty-wl-card) is gone (4f42297): THE CARD is the only card */
  var OPENER = '.svnty-qa .quick-add__submit[data-product-url]';
  var seen = new Set(), lastScroll = 0, pumpT = 0;
  function idle(fn) { if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 600 }); else setTimeout(fn, 50); }
  function schedule(ms) { if (pumpT) return; pumpT = setTimeout(function () { pumpT = 0; pump(); }, ms || 0); }
  function pump() {
    if (inflight || bytes >= BUDGET || slow() || misses >= 3) return;
    var rest = restUntil - performance.now(); if (rest > 0) { schedule(rest + 16); return; }
    var calm = performance.now() - lastScroll;
    if (calm < CALM_MS) { schedule(CALM_MS - calm + 16); return; }
    idle(function () {
      if (inflight || performance.now() - lastScroll < CALM_MS) { schedule(CALM_MS); return; }
      var cy = window.innerHeight / 2, cx = window.innerWidth / 2, best = null, bd = 1e9;
      seen.forEach(function (b) {
        if (!b.isConnected) { seen.delete(b); return; }
        var u = b.getAttribute('data-product-url'); if (!u || cached(u) || skip.has(u)) return;
        var r = b.getBoundingClientRect(); if (!r.width) return;
        var d = Math.abs((r.top + r.bottom) / 2 - cy) + Math.abs((r.left + r.right) / 2 - cx) * 0.5;
        if (d < bd) { bd = d; best = u; }
      });
      if (!best) return;
      prefetchUrl(best, true);
    });
  }
  function prefetchUrl(url, queued) {
    if (!url || cached(url) || skip.has(url) || slow() || inflight >= 1 || bytes >= BUDGET || misses >= 3) return false;
    inflight++;
    var pd = null;
    door(url).then(function (p) { pd = p; bytes += (p && p.bytes) || 0; return p && warm(p); }).then(function () {
      /* the picture counts against the budget too (its encoded size, from the resource timing, else a typical 90 KB) */
      if (pd && pd.img) { var t = null; try { t = performance.getEntriesByName(new URL(pd.img.currentSrc || pd.img.src, location.href).href)[0]; } catch (e) {} bytes += (t && (t.encodedBodySize || t.transferSize)) || 90000; }
      misses = 0; inflight--; schedule(0);
    }, function () { inflight--; skip.add(url); misses++; restUntil = performance.now() + 2000 * misses; schedule(2000 * misses); });
    return true;
  }
  var io = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (list) {
    list.forEach(function (x) { if (x.isIntersecting) seen.add(x.target); else seen.delete(x.target); });
    schedule(0);
  }) : null;
  function observe(root) { if (io) slice((root || document).querySelectorAll(OPENER)).forEach(function (b) { if (!b.__svntyIo) { b.__svntyIo = true; io.observe(b); } }); }
  window.addEventListener('scroll', function () { lastScroll = performance.now(); }, { passive: true, capture: true });
  function openerUrl(card) { var b = card && card.querySelector(OPENER); return b ? b.getAttribute('data-product-url') : null; }
  function prefetch(card) { return prefetchUrl(openerUrl(card)); }
  function cardOf(t) { var c = t && t.closest && t.closest(CARD); return c && c.querySelector('.svnty-qa') ? c : null; }
  /* the accelerators: a mouse (a fine pointer) resting 80 ms on a card */
  var hoverT = 0, hoverCard = null;
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var c = cardOf(e.target); if (c === hoverCard) return;
    clearTimeout(hoverT); hoverCard = c;
    if (c) hoverT = setTimeout(function () { if (hoverCard === c) { var u = openerUrl(c); if (u && !cached(u) && !slow()) door(u); } }, 80);
  }, { passive: true });
  /* a press on CHOOSE OPTIONS starts the door at once (a mouse), or once a finger has stayed 60 ms (a thumb that lands on the
     button to scroll never fetches); a finger held 150 ms elsewhere on the card prefetches */
  var hold = null;
  function dropHold() { if (hold) { clearTimeout(hold.t); hold = null; } }
  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('.svnty-qa .quick-add__submit');
    var u = b && b.getAttribute('data-product-url');
    if (u && e.pointerType !== 'touch') { if (!slow()) door(u); return; }
    if (e.pointerType !== 'touch') return;
    var c = cardOf(e.target); dropHold(); if (!c) return;
    hold = { x: e.clientX, y: e.clientY, t: setTimeout(function () { hold = null; if (u) door(u); else prefetch(c); }, u ? 60 : 150) };
  }, { passive: true });
  document.addEventListener('pointermove', function (e) { if (hold && (Math.abs(e.clientX - hold.x) > 8 || Math.abs(e.clientY - hold.y) > 8)) dropHold(); }, { passive: true });
  document.addEventListener('pointerup', dropHold, { passive: true });
  document.addEventListener('pointercancel', dropHold, { passive: true });
  document.addEventListener('scroll', dropHold, { passive: true, capture: true });
  document.addEventListener('focusin', function (e) {
    var b = e.target.closest && e.target.closest('.svnty-qa'); if (b && e.target.matches(':focus-visible')) { var u = openerUrl(b.closest(CARD)); if (u && !cached(u)) door(u); }
  });
  window.SVNTYDoor.prefetch = function (url) { if (!url || cached(url) || slow()) return false; door(url); return true; };

  /* ============================================================ 1. THE SIZE ROW */
  var open = null;   /* the one open .svnty-qa */

  /* P17-24: the card's data rides its own attribute (P17-16 moved it out of a script island per card); read once, kept on the node */
  function data(qa) {
    if (qa.__svntyData !== undefined) return qa.__svntyData;
    var j = qa.getAttribute('data-svnty-qa-json'), d = null;
    try { d = j ? JSON.parse(j) : null; } catch (e) { d = null; }
    return (qa.__svntyData = d);
  }
  function colourOf(qa) {
    var card = qa.closest(CARD), d = data(qa);
    var on = card && card.querySelector('.svnty-card__sw[aria-pressed="true"]');
    return (on && on.getAttribute('data-colour')) || (card && card.getAttribute('data-svnty-colour')) || (d && d.d) || '';
  }
  /* THE STRIPE NAME (D8-8, R239): the card's colour as the site prints it ("Blue stripe"): the swatch's data-svnty-name
     (snippets/svnty-card-swatches.liquid), else the default's name in the card data (dn); the value stays colourOf() */
  function nameOf(qa) {
    var c = colourOf(qa), card = qa.closest(CARD), d = data(qa);
    var sw = card && Array.prototype.find.call(card.querySelectorAll('.svnty-card__sw[data-svnty-name]'), function (b) { return b.getAttribute('data-colour') === c; });
    if (sw) return sw.getAttribute('data-svnty-name') || c;
    return (d && d.d === c && d.dn) || c;
  }
  function variants(qa) {
    var d = data(qa); if (!d || !d.v) return null;
    if (!d.c) return d.v;
    var c = colourOf(qa);
    var list = d.v.filter(function (v) { return v[1] === c; });
    /* C-27: a colour whose variants were not listed (the 120 cap) never borrows another colour's sizes: the door decides */
    return list.length ? list : null;
  }
  function titleOf(qa) { var a = qa.closest(CARD); a = a && a.querySelector('.card__heading a'); return a ? a.textContent.trim() : ''; }
  /* C-24: the colour on the card, wholly sold out */
  function colourOut(qa) { var d = data(qa), l = variants(qa); return !!(d && d.c && l && l.length && !l.some(function (v) { return v[3]; })); }
  /* P27-6 THE NOTIFY CARD (the collection and search grids only: data-svnty-qa-wish, printed with color_split and the notify lane on):
     the card's colour sold out in every size = one NOTIFY ME button and "Sold out" under the title; a colour with a size left = the
     normal card. Kept true when a swatch changes the colour; "You are on the list" once this browser asked for a size of the colour
     (svnty-notify.js's memory, 90 days), so a refresh keeps it said. */
  function allOut(qa) { var l = variants(qa); return !!(l && l.length && !l.some(function (v) { return v[3]; })); }
  function wishPaint(qa) {
    if (!qa.hasAttribute('data-svnty-qa-wish')) return;
    var lane = window.SVNTY && window.SVNTY.notify, out = allOut(qa) && !(lane && lane.on === false);
    var listed = out && !!lane && (variants(qa) || []).some(function (v) { return lane.remembered(v[0]); });
    if (qa.classList.contains('is-wish') !== out) qa.classList.toggle('is-wish', out);
    var card = qa.closest(CARD), line = card && card.querySelector('[data-svnty-card-out]');
    if (line && line.hidden === out) line.hidden = !out;
    var btn = qa.querySelector('[data-svnty-qa-notifyme]'), done = qa.querySelector('[data-svnty-qa-listed]');
    if (btn && btn.hidden !== listed) btn.hidden = listed;
    if (done && done.hidden === listed) done.hidden = !listed;
  }
  function onWish(btn) {
    var qa = btn.closest('[data-svnty-qa]'); if (!qa) return;
    if (qa.classList.contains('is-open')) {
      if (Date.now() - (qa.__svntyOpenedAt || 0) < 350) return;   /* C-29: a double tap is one tap */
      closeRow(qa, true); return;
    }
    openRow(qa);
  }
  /* D6-7 THE CARD'S BAG COUNT (R200): the bag is THE COUNTED ICON bound to this card's own count, read from the cart bus
     (assets/svnty-cart-bus.js): the lines of the card's product in the colour the card shows now (every line of a product
     with no colour option). Repainted on every svnty:cart, on a colour change, on a card's arrival. Never a block: the bag
     keeps opening THE SIZE ROW whatever the count. */
  function countOf(qa) {
    var bag = bagOf(qa), cart = window.SVNTY && window.SVNTY.cart; if (!bag || !cart) return 0;
    var d = data(qa), pos = (d && d.c) || 0;
    return cart.qty(bag.getAttribute('data-product-id'), pos, pos ? colourOf(qa) : '');
  }
  function bagLabel(qa) {
    wishPaint(qa);
    var bag = bagOf(qa); if (!bag) return;
    var n = countOf(qa), icon = bag.querySelector('svnty-counted-icon[data-bound]');
    if (icon && icon.getAttribute('data-svnty-count') !== String(n)) {
      /* a card's first count (on load, on arrival) is painted still; only a change the shopper made ticks and bumps */
      if (!icon.__svntyPainted) icon.__svntyQuiet = true;
      icon.setAttribute('data-svnty-count', String(n));
    }
    if (icon && window.SVNTY && window.SVNTY.cart && window.SVNTY.cart.ready) icon.__svntyPainted = true;
    if (bag.disabled) return;
    var base = STR('quick_add', bag.getAttribute('data-svnty-qa-label') || 'Quick add to bag');
    bag.setAttribute('aria-label', colourOut(qa) ? STR('colour_sold_out', 'Sold out in this color')
      : n > 0 ? STR('bag_in', '[label], [n] in bag').replace('[label]', base).replace('[n]', String(n)) : base);
  }
  function paintAll(e) {
    var quiet = !!(e && e.detail && e.detail.quiet);
    slice(document.querySelectorAll('.svnty-qa')).forEach(function (qa) {
      if (quiet) { var ic = qa.querySelector('[data-svnty-qa-bag] svnty-counted-icon[data-bound]'); if (ic) ic.__svntyQuiet = true; }
      bagLabel(qa);
    });
  }
  document.addEventListener('svnty:cart', paintAll);
  function live(qa, text) { var l = qa.querySelector('[data-svnty-qa-live]'); if (!l) return; l.textContent = ''; setTimeout(function () { l.textContent = text; }, 30); }
  function bagOf(qa) { return qa.querySelector('[data-svnty-qa-bag]'); }

  function chipsHtml(qa) {
    var box = qa.querySelector('[data-svnty-qa-chips]'); if (!box) return;
    var list = variants(qa) || [];
    box.textContent = '';
    list.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'svnty-qa__chip' + (v[3] ? '' : ' is-out');
      b.setAttribute('data-variant', String(v[0]));
      b.setAttribute('data-size', v[2] || '');
      var t = document.createElement('span'); t.className = 'svnty-qa__chip-t'; t.textContent = v[2] || '';
      b.appendChild(t);
      var sp = document.createElement('span'); sp.className = 'svnty-qa__spin'; sp.setAttribute('aria-hidden', 'true'); b.appendChild(sp);
      if (!v[3]) { b.setAttribute('aria-disabled', 'true'); b.setAttribute('aria-label', (v[2] || '') + ', ' + STR('sold_out', 'Sold out')); }
      box.appendChild(b);
    });
    box.scrollLeft = 0;
  }
  function fades(box) {
    var more = box.scrollWidth - box.clientWidth > 2;
    box.toggleAttribute('data-more-end', more && box.scrollLeft + box.clientWidth < box.scrollWidth - 1);
    box.toggleAttribute('data-more-start', more && box.scrollLeft > 1);
  }

  function watch(qa) {
    var card = qa.closest(CARD); if (!card || typeof MutationObserver !== 'function') return;
    var last = colourOf(qa);
    qa.__svntyMo = new MutationObserver(function () {
      var now = colourOf(qa);
      if (now !== last && qa.classList.contains('is-open') && !qa.classList.contains('is-busy')) {
        last = now;
        if (colourOut(qa) || !variants(qa)) { closeRow(qa, false); return; }
        /* P17-26 (found by the fast add guard's Q4 then Q5): a notify row open for the old colour's sold-out size stayed over the
           new colour's chips, and its email would have gone out with the old variant under the new colour's name. The new
           colour's size row takes the place back (a send already on its way finishes first); the focus follows only if it was
           in the email row */
        var nf = qa.querySelector('[data-svnty-qa-notify]'), sr = qa.querySelector('[data-svnty-qa-sizes]'), inNf = false;
        if (qa.classList.contains('is-notify') && nf && !nf.classList.contains('is-busy')) {
          inNf = nf.contains(document.activeElement);
          closeNotify(qa, false);
          if (sr) sr.hidden = false;
        }
        chipsHtml(qa); fades(qa.querySelector('[data-svnty-qa-chips]'));
        if (inNf && sr) { var c1 = sr.querySelector('.svnty-qa__chip:not(.is-out)') || sr.querySelector('.svnty-qa__chip'); if (c1) try { c1.focus({ preventScroll: true }); } catch (e) { c1.focus(); } }
      }
    });
    qa.__svntyMo.observe(card, { subtree: true, attributes: true, attributeFilter: ['aria-pressed', 'data-svnty-colour'] });
  }

  function openRow(qa) {
    if (open && open !== qa) closeRow(open, false);
    chipsHtml(qa);
    var row = qa.querySelector('[data-svnty-qa-sizes]');
    row.hidden = false;
    /* C-10: the fade is measured once the row has a width (a hidden row measured 0 and never showed "more sizes") */
    fades(qa.querySelector('[data-svnty-qa-chips]'));
    qa.__svntyOpenedAt = Date.now();
    qa.classList.add('is-open');
    bagOf(qa).setAttribute('aria-expanded', 'true');
    var wb = qa.querySelector('[data-svnty-qa-notifyme]'); if (wb) wb.setAttribute('aria-expanded', 'true');
    open = qa;
    watch(qa);
    /* P27-6: on THE NOTIFY CARD every chip is sold out and each one asks; the first size takes the focus */
    var first = row.querySelector('.svnty-qa__chip:not(.is-out)') || (qa.classList.contains('is-wish') && row.querySelector('.svnty-qa__chip')) || row.querySelector('[data-svnty-qa-close]');
    if (first) try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    measureRows();
  }
  function closeRow(qa, focusBag) {
    if (!qa) return;
    clearTimeout(qa.__svntyT);
    var row = qa.querySelector('[data-svnty-qa-sizes]'), msg = qa.querySelector('[data-svnty-qa-msg]');
    var had = qa.contains(document.activeElement);
    if (row) row.hidden = true;
    if (msg) msg.hidden = true;
    var nf = qa.querySelector('[data-svnty-qa-notify]'); if (nf) { nf.hidden = true; nf.classList.remove('is-busy'); }
    qa.classList.remove('is-open', 'is-msg', 'is-busy', 'is-added', 'is-na', 'is-notify');
    var bag = bagOf(qa); bag.setAttribute('aria-expanded', 'false'); bag.classList.remove('is-busy');
    var wb = qa.querySelector('[data-svnty-qa-notifyme]'); if (wb) wb.setAttribute('aria-expanded', 'false');
    if (qa.__svntyMo) { qa.__svntyMo.disconnect(); qa.__svntyMo = null; }
    if (open === qa) open = null;
    /* P27-6: on THE NOTIFY CARD the bag is not drawn; focus goes home to NOTIFY ME (or stays on the card when it is listed) */
    var home = qa.classList.contains('is-wish') ? (wb && !wb.hidden ? wb : null) : bag;
    if ((focusBag || had) && home) try { home.focus({ preventScroll: true }); } catch (e) { home.focus(); }
    measureRows();
  }
  function message(qa, kind, words) {
    var msg = qa.querySelector('[data-svnty-qa-msg]'), row = qa.querySelector('[data-svnty-qa-sizes]');
    var had = qa.contains(document.activeElement);
    msg.textContent = '';
    if (kind === 'added') {
      var svg = window.SVNTY && window.SVNTY.icon ? window.SVNTY.icon('check', 16, 1.6) : null;   /* THE ICON LAW (D11-7): the family's tick */
      if (svg) msg.appendChild(svg);
    }
    var t = document.createElement('span'); t.textContent = words || (kind === 'added' ? STR('added', 'Added') : STR('not_available', 'Not available')); msg.appendChild(t);
    if (row) row.hidden = true;
    msg.hidden = false;
    qa.classList.remove('is-busy');
    qa.classList.add('is-msg', kind === 'added' ? 'is-added' : 'is-na');
    bagOf(qa).classList.remove('is-busy');
    if (had) { msg.setAttribute('tabindex', '-1'); try { msg.focus({ preventScroll: true }); } catch (e) {} }
    clearTimeout(qa.__svntyT);
    qa.__svntyT = setTimeout(function () { closeRow(qa, qa.contains(document.activeElement)); }, kind === 'added' ? ADDED_MS : NA_MS);
  }

  function add(qa, variantId, sizeLabel, busyEl) {
    if (qa.classList.contains('is-busy')) return;
    if (typeof window.SVNTYCartAdd !== 'function') { message(qa, 'na'); return; }
    qa.classList.add('is-busy');
    if (busyEl) busyEl.classList.add('is-busy');
    var fd = new FormData(); fd.append('id', String(variantId)); fd.append('quantity', '1');
    window.SVNTYCartAdd(fd, 'svnty-card').then(function (res) {
      if (busyEl) busyEl.classList.remove('is-busy');
      if (res && res.ok) {
        var item = titleOf(qa) + (sizeLabel ? ', ' + sizeLabel : '');
        live(qa, STR('added_line', '[item] added to your bag').replace('[item]', item));
        message(qa, 'added');
      } else {
        /* C-20: the store's own sentence when it gave one ("All 1 Hoodie ... are in your cart."), never a futile "try again" */
        var why = res && res.data && typeof res.data.description === 'string' ? res.data.description : '';
        live(qa, why || (sizeLabel ? STR('na_line', 'That size could not be added.') : STR('na_piece', 'That piece could not be added.')));
        /* P28-4 (lane G P2-1): only the stock's own refusal (422) may say Not available; a busy store or a dropped line says it plainly */
        var stock = res && res.data && res.data.status === 422;
        message(qa, 'na', stock ? undefined : ((window.svntyStrings && window.svntyStrings.add_error) || 'Could not add to bag'));
      }
    });
  }

  function onBag(bag) {
    var qa = bag.closest('[data-svnty-qa]'); if (!qa || bag.disabled) return;
    if (qa.querySelector('.quick-add__submit.loading')) return;   /* C-28: the door is on its way */
    if (qa.classList.contains('is-added')) closeRow(qa, false);   /* D6-7: the bag beside "Added" adds again at once */
    if (qa.classList.contains('is-open')) {
      if (Date.now() - (qa.__svntyOpenedAt || 0) < 350) return;   /* C-29: a double tap is one tap */
      closeRow(qa, true); return;
    }
    if (open && open !== qa) closeRow(open, false);
    if (colourOut(qa)) {
      /* C-24: a colour sold out in every size says so in the row, never six struck chips */
      var c = nameOf(qa);
      live(qa, STR('colour_sold_line', '[colour] is sold out').replace('[colour]', c));
      message(qa, 'na', STR('colour_sold_out', 'Sold out in this color'));
      return;
    }
    var list = variants(qa);
    if (!list) {
      var direct = bag.getAttribute('data-variant');
      if (direct) { add(qa, direct, '', bag); return; }
      var opener = qa.querySelector('.quick-add__submit'); if (opener) opener.click();
      return;
    }
    if (list.length === 1) {
      if (list[0][3]) add(qa, list[0][0], list[0][2], bag);
      else { live(qa, STR('sold_line', '[size] is sold out').replace('[size]', list[0][2] || titleOf(qa))); message(qa, 'na'); }
      return;
    }
    openRow(qa);
  }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var wish = t.closest('[data-svnty-qa-notifyme]');
    if (wish) { e.preventDefault(); onWish(wish); return; }
    var bag = t.closest('[data-svnty-qa-bag]');
    if (bag) { e.preventDefault(); onBag(bag); return; }
    var x = t.closest('[data-svnty-qa-close]');
    if (x) {
      e.preventDefault();
      var xq = x.closest('[data-svnty-qa]');
      if (Date.now() - (xq.__svntyOpenedAt || 0) < 350) return;   /* C-29: the double tap's second tap lands on the X */
      closeRow(xq, true); return;
    }
    var chip = t.closest('.svnty-qa__chip');
    if (chip) {
      e.preventDefault();
      var qa = chip.closest('[data-svnty-qa]');
      if (chip.getAttribute('aria-disabled') === 'true') {
        /* D11-7: a sold-out size opens the card's notify row (the lane on), else the old word */
        if (window.SVNTY && window.SVNTY.notify && window.SVNTY.notify.on) { openNotify(qa, chip); return; }
        live(qa, STR('sold_line', '[size] is sold out').replace('[size]', chip.getAttribute('data-size') || '')); return;
      }
      add(qa, chip.getAttribute('data-variant'), chip.getAttribute('data-size'), chip);
    }
  });
  /* ---- D11-7 THE CARD's NOTIFY ROW: a sold-out size chip turns the size row into an email row at the same height (THE ROW LAW);
     one template (snippets/svnty-glyphs.liquid) cloned into the card on first use; the answer in the card's own message row ---- */
  function handleOf(qa) { var c = qa.closest(CARD), a = c && c.querySelector('.card__heading a'); var m = a && /\/products\/([a-z0-9][a-z0-9-]*)/i.exec(a.getAttribute('href') || ''); return m ? m[1] : ''; }
  var notifySeq = 0;
  function notifyRowOf(qa) {
    var f = qa.querySelector('form.svnty-qa__notify'); if (f) return f;
    var tpl = document.querySelector('template[data-svnty-qa-notify]'); if (!tpl || !tpl.content) return null;
    f = tpl.content.querySelector('form').cloneNode(true); f.hidden = true; f.noValidate = true; f.setAttribute('data-svnty-qa-notify', '');
    notifySeq += 1; f.id = 'SvntyQaNotify-' + notifySeq;   /* one id per card; the action's #anchor is never followed (fetch) */
    qa.appendChild(f);
    f.addEventListener('submit', function (e) { if (f.__svntyNative) return; e.preventDefault(); sendNotify(qa, f); });
    f.querySelector('[data-svnty-qa-notify-close]').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closeNotify(qa, true); });
    f.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeNotify(qa, true); } });
    return f;
  }
  function openNotify(qa, chip) {
    var f = notifyRowOf(qa); if (!f) return;
    var lane = window.SVNTY.notify, vid = chip.getAttribute('data-variant'), size = chip.getAttribute('data-size') || '';
    if (lane.remembered(vid)) { message(qa, 'na', STR('notify_already', 'Already on the list for [size]').replace('[size]', size)); return; }
    f.setAttribute('data-variant', vid); f.setAttribute('data-size', size);
    /* P27-6: on THE NOTIFY CARD the row's button says JOIN (the card's own button already said NOTIFY ME) */
    var go = f.querySelector('.svnty-qa__notify-go'); if (go) { if (!go.hasAttribute('data-svnty-go')) go.setAttribute('data-svnty-go', go.textContent); go.textContent = qa.classList.contains('is-wish') ? STR('notify_join', 'Join') : go.getAttribute('data-svnty-go'); }
    var tags = f.querySelector('[data-svnty-qa-notify-tags]'); if (tags) tags.value = lane.tags(vid, handleOf(qa));
    var row = qa.querySelector('[data-svnty-qa-sizes]'); if (row) row.hidden = true;
    f.hidden = false; qa.classList.add('is-notify');
    live(qa, STR('notify_open', 'Your email for [size]: we will tell you when it is back').replace('[size]', size));
    var em = f.querySelector('[name="contact[email]"]'); if (em) { try { em.focus({ preventScroll: true }); } catch (e) { /* no focus */ } }
  }
  function closeNotify(qa, back) {
    var f = qa.querySelector('form.svnty-qa__notify'); if (f) { f.hidden = true; f.classList.remove('is-busy'); }
    qa.classList.remove('is-notify');
    if (back) { var row = qa.querySelector('[data-svnty-qa-sizes]'); if (row && qa.classList.contains('is-open')) { row.hidden = false; var c = row.querySelector('.svnty-qa__chip'); if (c) { try { c.focus({ preventScroll: true }); } catch (e) { /* no focus */ } } } }
  }
  /* P27 (TH-4): Shopify's customer form, posted by fetch(FormData) to its own action; Shopify answers with a redirect to the page plus
     customer_posted=true. A challenge page (Shopify's bot check) or no answer at all = the same form posted natively (the page reloads here,
     and assets/svnty-notify.js remembers the ask on the way back). G9 in NOTIFY_ME_NATIVE_Part27.md. */
  function sendNotify(qa, f) {
    var lane = window.SVNTY && window.SVNTY.notify; if (!lane) return;
    if (f.classList.contains('is-busy')) return;
    var em = f.querySelector('[name="contact[email]"]'), value = em ? String(em.value || '').trim() : '', size = f.getAttribute('data-size') || '';
    var box = f.querySelector('[data-svnty-qa-consent]'), vid = f.getAttribute('data-variant');
    if (!lane.validEmail(value)) { if (em) { em.setAttribute('aria-invalid', 'true'); em.focus(); } live(qa, STR('notify_email_bad', 'Please check the email address')); return; }
    if (em) em.removeAttribute('aria-invalid');
    if (box && !box.checked) { f.classList.add('is-consent'); try { box.focus({ preventScroll: true }); } catch (e) { /* no focus */ } live(qa, STR('notify_consent_needed', 'Tick the box to join the list')); return; }
    f.classList.remove('is-consent');
    if (lane.cap(vid)) { closeNotify(qa, false); message(qa, 'na', STR('notify_cap', 'Already on the list for 20 pieces')); return; }
    var tags = f.querySelector('[data-svnty-qa-notify-tags]'); if (tags) tags.value = lane.tags(vid, handleOf(qa));
    f.classList.add('is-busy');
    lane.stamp(vid, 'card');
    function native() { f.__svntyNative = true; f.noValidate = false; HTMLFormElement.prototype.submit.call(f); }
    fetch(f.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(f), credentials: 'same-origin', redirect: 'follow' })
      .then(function (r) {
        var url = String(r.url || '');
        if (/[?&]customer_posted=true/.test(url)) {
          lane.clearStamp(); lane.remember(vid);
          f.classList.remove('is-busy'); closeNotify(qa, false);
          /* P27-6: THE NOTIFY CARD says it once and keeps it said ("You are on the list", painted again on every load) */
          if (qa.classList.contains('is-wish')) { message(qa, 'na', STR('notify_listed', 'You are on the list')); wishPaint(qa); return; }
          message(qa, 'na', STR('notify_done', 'On the list for [size]').replace('[size]', size));
          return;
        }
        if (/\/challenge/.test(url) || !r.ok) { native(); return; }
        lane.clearStamp();
        f.classList.remove('is-busy');
        if (em) em.setAttribute('aria-invalid', 'true');
        live(qa, STR('notify_email_bad', 'Please check the email address'));
      })
      .catch(function () { native(); });
  }
  /* outside: a press anywhere off the card closes the open row (focus stays where the shopper went); the card's own
     swatches are inside, they repaint the chips */
  document.addEventListener('pointerdown', function (e) {
    if (!open || open.classList.contains('is-busy')) return;
    var c = open.closest(CARD) || open;
    if (e.target.closest && e.target.closest(CARD) === c) return;
    closeRow(open, false);
  }, true);
  /* C-22: the KEYBOARD leaving the card closes the row. Only a Tab moves it: a press on a chip or the X hands focus to the
     page's <main> in WebKit (buttons take no focus on click), and that must never close the row under the shopper's tap */
  var lastTab = 0;
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') lastTab = Date.now(); }, true);
  document.addEventListener('focusout', function (e) {
    if (!open || open.classList.contains('is-busy') || !e.relatedTarget || Date.now() - lastTab > 300) return;
    var c = open.closest(CARD) || open;
    if (c.contains(e.target) && !c.contains(e.relatedTarget)) closeRow(open, false);
  });
  /* C-17: a layer over the door (the size sheet, the paired sheet, the viewer) takes Escape for itself; its own handler
     may close it before ours runs, so whether one was open is read first, in the window's capture phase */
  var LAYERS = '[data-svnty-ssheet].is-open, .svnty-paired.is-open, svnty-viewer[open]', layerAtKey = false;
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape') layerAtKey = !!document.querySelector(LAYERS); }, true);
  window.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape' || !layerAtKey) return;
    layerAtKey = false;
    if (e.target && e.target.closest && e.target.closest('quick-add-modal')) e.stopPropagation();   /* Trade's ModalDialog closes on keyup */
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !open) return;
    if (document.querySelector('quick-add-modal[open]')) return;
    e.stopPropagation(); closeRow(open, true);
  }, true);
  document.addEventListener('scroll', function (e) { var b = e.target; if (b && b.classList && b.classList.contains('svnty-qa__chips')) fades(b); }, true);

  /* THE LOADING STATE of CHOOSE OPTIONS: the button keeps its width while the label hides (the CSS), and the modal's
     loading class is mirrored on the action row so the bag stays still beside it */
  function wire(root) {
    slice((root || document).querySelectorAll('.svnty-qa')).forEach(function (qa) {
      if (qa.__svntyWired) return; qa.__svntyWired = true;
      var bag = bagOf(qa); if (bag && !bag.hasAttribute('data-svnty-qa-label')) bag.setAttribute('data-svnty-qa-label', bag.getAttribute('aria-label') || '');
      bagLabel(qa);
    });
  }
  window.SVNTYQa = { label: function (card) { var qa = card && card.querySelector('[data-svnty-qa]'); if (qa) bagLabel(qa); } };
  /* the count follows the colour the card shows (the swatch swap writes data-svnty-colour and the pressed swatch) */
  if (typeof MutationObserver === 'function') new MutationObserver(function (list) {
    var seen = [];
    list.forEach(function (x) {
      var c = x.target.closest && x.target.closest(CARD), qa = c && c.querySelector('[data-svnty-qa]');
      if (qa && seen.indexOf(qa) < 0) { seen.push(qa); bagLabel(qa); }
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['data-svnty-colour', 'aria-pressed'] });
  /* THE DOOR'S FOCUS: Trade's trapFocus asks the dialog for focus in the same task that opens it, before the door's own
     styles apply, and WebKit refuses (measured: focus stayed on <body>, so Escape, heard on the modal, did nothing). The
     dialog takes focus once it is shown; Escape closes an open door wherever focus is, and focus goes home to the opener
     (ModalDialog.hide). */
  function doorOpened(m) {
    /* P17-17 (eye pass P2-9): an open door dismisses the added-to-bag toast (its own hide, which never yanks a focused toast);
       held about 6 s at the phone's foot, it covered the door's price and its SELECT A SIZE */
    try { if (window.SVNTYToast && typeof window.SVNTYToast.hide === 'function') window.SVNTYToast.hide(); } catch (e) {}
    setTimeout(function () {
      if (!m.hasAttribute('open') || m.contains(document.activeElement)) return;
      var d = m.querySelector('[role="dialog"]'); if (d) try { d.focus({ preventScroll: true }); } catch (e) { d.focus(); }
    }, 60);
  }
  if (typeof MutationObserver === 'function') new MutationObserver(function (list) {
    list.forEach(function (x) { if (x.target.tagName === 'QUICK-ADD-MODAL' && x.target.hasAttribute('open')) doorOpened(x.target); });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var m = document.querySelector('quick-add-modal[open]');
    if (!m || m.contains(document.activeElement) || typeof m.hide !== 'function') return;
    if (layerAtKey || document.querySelector(LAYERS)) return;
    m.hide();
  });
  function boot() { wire(document); observe(document); schedule(300); }
  /* P27-6: svnty-notify.js (the memory) runs after this file (both deferred, in document order); the notify cards are painted again
     once every deferred script has run, so "You are on the list" is there on a refresh */
  function wishAll() { slice(document.querySelectorAll('.svnty-qa[data-svnty-qa-wish]')).forEach(wishPaint); }
  if (document.readyState === 'complete') wishAll(); else document.addEventListener('DOMContentLoaded', wishAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  if (typeof MutationObserver === 'function') new MutationObserver(function (m) {
    m.forEach(function (x) { x.addedNodes.forEach(function (n) { if (n.nodeType === 1 && (n.matches('.svnty-qa') || n.querySelector('.svnty-qa'))) { wire(n); observe(n.parentNode || n); } }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 3. THE KEYBOARD RING ON TOUCH (P17-17, PERF_A11Y P1-4). A coarse pointer is not the absence of a keyboard: an iPad with a
 *    keyboard, a Bluetooth keyboard on an iPhone and Full Keyboard Access all report (pointer: coarse), where svnty-touch.css
 *    kills every ring for the sake of taps. html.svnty-kbd names the input instead: a Tab key sets it, the next pointer click
 *    (detail above 0; a key's own click has 0) clears it once the tap has landed, so nothing is written between a press and its
 *    click (THE iOS TAP LAW). assets/svnty-tokens.css brings the desktop's ring back under it. This file loads on every page. */
(function () {
  'use strict';
  var root = document.documentElement, KBD = 'svnty-kbd';
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' && !root.classList.contains(KBD)) root.classList.add(KBD);
  }, true);
  document.addEventListener('click', function (e) {
    if (e.detail > 0 && root.classList.contains(KBD)) root.classList.remove(KBD);
  }, true);
})();
